// extracted by mini-css-extract-plugin
export default {"MainDropdownWrapper":"MainDropdown_MainDropdownWrapper__zFImr","MainDropdown":"MainDropdown_MainDropdown__CpORS"};